/** Border definition matching the one defined by mantine. */
.imgBorder {
	border: calc(0.0625rem * var(--mantine-scale)) solid
		var(--mantine-color-default-border);
}
